import React from 'react';
import { Phone, Mail, MessageSquare } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white text-center py-8 px-4 mt-auto">
      <div className="max-w-7xl mx-auto">
        
        {/* Copyright */}
        <div className="mb-4">
          <p className="font-semibold text-lg">© 2026 Sainik Shiromani Sikheda</p>
          <p className="font-semibold">सैनिक शिरोमणि सिखेड़ा</p>
        </div>
        
        {/* Navigation Links */}
        <div className="mb-6 space-x-4">
          <a href="/" className="hover:underline">Home</a>
          <span className="text-gray-500">|</span>
          <a href="/contact" className="hover:underline">Contact</a>
          <span className="text-gray-500">|</span>
          <a href="/privacy-policy" className="hover:underline">Privacy Policy</a>
        </div>
        
        {/* Action Icons */}
        <div className="flex justify-center items-center space-x-6">
          <a href="tel:+919999999999" aria-label="Call us" className="flex flex-col items-center text-blue-300 hover:text-white transition-colors">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-blue-500 hover:bg-blue-600 mb-1">
                <Phone size={24} />
            </div>
            <span className="text-xs">Call</span>
          </a>
          <a href="https://wa.me/919999999999" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp us" className="flex flex-col items-center text-green-300 hover:text-white transition-colors">
             <div className="w-12 h-12 flex items-center justify-center rounded-full bg-green-500 hover:bg-green-600 mb-1">
                <MessageSquare size={24} />
            </div>
            <span className="text-xs">WhatsApp</span>
          </a>
          <a href="mailto:contact@sikheda.gov.in" aria-label="Email us" className="flex flex-col items-center text-red-300 hover:text-white transition-colors">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-red-500 hover:bg-red-600 mb-1">
                <Mail size={24} />
            </div>
            <span className="text-xs">Email</span>
          </a>
        </div>

      </div>
    </footer>
  );
}

export default Footer;
